<div class="flex flex-col notifications-list">
  
  <app-sidenav-header [title]="title"></app-sidenav-header>

  <ng-container *ngIf="notifications.length > 0; else showNoNotificationsLabel">
    <div class="flex flex-row flex-auto justify-between items-center w-100-percent">
      <div class="clear-all mat-small fw-700 mb-16 cursor-pointer ml-auto mr-8" (click)="openClearAllModal()">
        {{'NOTIFICATIONS.CLEAR_ALL' | transloco}}
      </div>
    </div>
    <app-notification-card class="mb-16" [ngClass]="{'cursor-pointer': !notification.state.read}" *ngFor="let notification of notifications; let i = index" 
      [notification]="notification" (cleared)="onClearNotification($event, i)"  (click)="markAsRead(notification)"></app-notification-card>
  </ng-container>

  <ng-template #showNoNotificationsLabel>
    <div class="flex flex-col items-center ta-center mt-80">
      <div class="flex justify-center items-center notification-wrapper h-98 w-98">
        <div class="flex justify-center items-center notification-icon h-78 w-78">
          <mat-icon svgIcon="notifications" class="icon h-50 w-42"></mat-icon>
        </div>
      </div>
      <div class="mat-headline-6 mt-24 mb-4 fw-700">
        {{'NOTIFICATIONS.NO_NOTIFICATIONS_HEADER' | transloco}}
      </div>
      <div class="neutral-blue mb-32 mat-subtitle-2 fw-500">
        {{'NOTIFICATIONS.NO_NOTIFICATIONS_BODY' | transloco}}
      </div>
    </div>
  </ng-template>
  
  <span class="flex-auto"></span>
</div>
